// extracted by mini-css-extract-plugin
module.exports = {"container":"bG_x","cropper":"bG_fm","resizer":"bG_fn","hover":"bG_cV"};